import { type WithRef } from '@principle-theorem/shared';
import { getCustomMappingsHandler } from './custom-mappings-handler';
import {
  type ICustomMapping,
  type ICustomMappingHandler,
  type IPracticeMigration,
} from '@principle-theorem/practice-migrations/interfaces';

export function getCustomMappingHandler(
  migration: WithRef<IPracticeMigration>,
  customMapping: WithRef<ICustomMapping>
): ICustomMappingHandler | undefined {
  const handler = getCustomMappingsHandler(migration);
  if (!handler) {
    return;
  }

  return handler.mappingHandlers.find((mappingHandler) =>
    mappingHandler.canHandle(customMapping)
  );
}

export function hasDestinationCompletenessCheck(
  handler: ICustomMappingHandler
): handler is ICustomMappingHandler & { requireDestinationCompleteness: true } {
  return handler.requireDestinationCompleteness === true;
}
